import { computed, defineComponent } from 'vue';
export default defineComponent({
    props: {
        modelValue: String,
        options: {
            type: Array,
            default: () => {
                return [];
            }
        },
        disabled: Boolean,
        withoutBorder: Boolean
    },
    emits: ['update:modelValue'],
    setup(props, { emit }) {
        const value = computed({
            get() {
                var _a;
                return ((_a = props.modelValue) === null || _a === void 0 ? void 0 : _a.split(',')) || [];
            },
            set(value) {
                emit('update:modelValue', (value.length && value.join(',')) || '');
            }
        });
        return { value };
    }
});
